import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function AdminKennelImages() {
  const [kennels, setKennels] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const adminId = localStorage.getItem('playerId');

  useEffect(() => {
    if (!adminId) return;

    const fetchPendingKennelImages = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/admin/kennel-images-pending?adminId=${adminId}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setKennels(data);
      } catch (err) {
        setMessage('Failed to fetch pending kennel images: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingKennelImages();
  }, [adminId]);

  const approveImage = async (kennelId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/admin/kennel-images-approve`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kennelId, adminId })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setKennels(kennels.filter(k => k._id !== kennelId));
      setMessage(data.message);
    } catch (error) {
      setMessage('Failed to approve image: ' + error.message);
    }
  };

  const denyImage = async (kennelId, denyReason) => {
    if (!denyReason) {
      setMessage('Please provide a reason for denial.');
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/admin/kennel-images-deny`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kennelId, adminId, denyReason })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setKennels(kennels.filter(k => k._id !== kennelId));
      setMessage(data.message);
    } catch (error) {
      setMessage('Failed to deny image: ' + error.message);
    }
  };

  if (!adminId) return <p style={{ textAlign: 'center', color: '#333' }}>Please log in as an admin.</p>;
  if (loading) return <p style={{ textAlign: 'center', color: '#888' }}>Loading...</p>;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ color: '#1E88E5', textAlign: 'center', marginBottom: '20px' }}>Kennel Image Approvals</h1>
      {message && (
        <p style={{
          backgroundColor: '#BBDEFB',
          padding: '10px',
          borderRadius: '5px',
          color: '#333',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          {message}
        </p>
      )}
      {kennels.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#888' }}>No pending kennel image updates.</p>
      ) : (
        kennels.map(kennel => (
          <div key={kennel._id} style={{
            backgroundColor: '#f9f9f9',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #d9ead3'
          }}>
            <h2 style={{ color: '#4CAF50', marginBottom: '10px' }}>{kennel.kennelName}</h2>
            <p><strong>Current Image:</strong> {kennel.artUrl ? <a href={kennel.artUrl} target="_blank" rel="noopener noreferrer">{kennel.artUrl}</a> : 'None'}</p>
            <p><strong>Pending Image:</strong> <a href={kennel.pendingArtUrl} target="_blank" rel="noopener noreferrer">{kennel.pendingArtUrl}</a></p>
            <p><strong>Player ID:</strong> {kennel.playerId}</p>
            <div style={{ marginTop: '15px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={() => approveImage(kennel._id)}
                style={{
                  padding: '8px 15px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
                onMouseOver={e => e.target.style.backgroundColor = '#45A049'}
                onMouseOut={e => e.target.style.backgroundColor = '#4CAF50'}
              >
                Approve
              </button>
              <div style={{ display: 'flex', gap: '10px' }}>
                <input
                  type="text"
                  placeholder="Deny reason"
                  id={`deny-reason-${kennel._id}`}
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #BBDEFB',
                    fontSize: '1em'
                  }}
                />
                <button
                  onClick={() => denyImage(kennel._id, document.getElementById(`deny-reason-${kennel._id}`).value)}
                  style={{
                    padding: '8px 15px',
                    backgroundColor: '#EF5350',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={e => e.target.style.backgroundColor = '#F44336'}
                  onMouseOut={e => e.target.style.backgroundColor = '#EF5350'}
                >
                  Deny
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default AdminKennelImages;